// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.

export const environment = {
    production: false,
    /** Web app (post-checkout redirect). */
    appUrl: "https://app.rayalina.com",
    /** Base URL for Rayalina API (same auth contract as E-tsena: POST /auth/login, /auth/register). */
    apiUrl: "http://localhost:3000",
    /** When true, opens Google/Facebook OAuth in a popup against `${apiUrl}/auth/google` etc. */
    enableSocialLogin: false,
    /** When true, `AuthService` simulates login/register without calling `apiUrl`. Set false when the backend is ready. */
    useMockAuth: true,
    /** When true, `PricingService` serves embedded mock plans instead of GET `/website/pricing-plans`. */
    useMockPricing: true,
    /**
     * When true, `UssdMobileMoneyPaymentService` simule la demande USSD et le passage à PAID sans NestJS.
     * Désactivez quand les routes `/payments/ussd-mobile-money/...` sont disponibles.
     */
    useMockPayments: true,
};
